import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Font,
  Image,
} from "@react-pdf/renderer";
const borderColor = "#000";
import dayjs from "dayjs";
import { ToWords } from "to-words";
// Font.register({
//     family: 'roboto',
//     src: 'http://fonts.gstatic.com/s/roboto/v16/zN7GBFwfMP4uA6AR0HCoLQ.ttf'
//   });

const styles = StyleSheet.create({
  page: {
    flexDirection: "row",
    // backgroundColor: '#f6fbff',
    // height: 1000,
    // width: 1200,
    padding: 20,
  },
  container: {
    borderWidth: 2,
    borderColor: borderColor,
  },
  invoice: {
    marginTop: 6,
    display: "flex",
    fontSize: 11,
    flexDirection: "row",
    justifyContent: "space-between",
    padding: 4,
  },
  logoContainer: {
    display: "flex",
    flexDirection: "row",
    marginTop: 20,
    marginBottom: 20,
  },
  myLeftLogo: {
    width: "35%",
    fontSize: 11,
    textAlign: "center",
  },
  myRightTitle: {
    width: "65%",
    fontSize: 11,
    alignItems: "center",
    textAlign: "center",
  },
  logo: {
    width: 150,
    height: 50,
    objectFit: "contain",
  },

  title: {
    marginTop: 10,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    fontFamily: "Times-Roman",
  },
  busenessName: {
    marginBottom: 5,
    textAlign: "center",
    fontSize: 26,
  },
  businessAddress: {
    fontSize: 12,
    marginBottom: 10,
  },
  customerinfo: {
    borderTopWidth: 2,
    borderBottomWidth: 2,
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "row",
    flexWrap: "wrap",
    fontSize: 11,
    fontWeight: "bold",
  },
  name: {
    margin: 3,
    // fontFamily:"roboto",
    fontWeight: 800,
  },
  basicInfo: {
    padding: 5,
  },
  invoiceNo: {
    borderLeftWidth: 2,
    padding: 5,
  },
  billContanier: {
    flexDirection: "row",
    alignItems: "start",
    textAlign: "start",
    // borderBottomWidth:2
  },
  billadd: {
    width: "65%",
    borderRightColor: borderColor,
    borderRightWidth: 2,
    borderTopWidth: 2,
    fontSize: 11,
    textAlign: "justify",
    fontWeight: "heavy",
    padding: 4,
  },
  shippAdd: {
    borderTopWidth: 2,
    borderRightColor: borderColor,
    width: "35%",
    fontSize: 11,
    textAlign: "justify",
    padding: 4,
  },
  itemContainer: {
    display: "flex",
    flexDirection: "row",
    borderBottomWidth: 2,
  },
  sNo: {
    width: "10%",
    borderRightColor: borderColor,
    borderTopWidth: 2,
    fontSize: 12,
    textAlign: "justify",
    fontWeight: "heavy",
    padding: 4,
  },
  itemName: {
    width: "55%",
    borderRightColor: borderColor,
    borderRightWidth: 2,
    borderTopWidth: 2,
    borderLeftWidth: 2,
    fontSize: 12,
    textAlign: "center",
    padding: 4,
  },
  itemPrice: {
    width: "15%",
    borderRightColor: borderColor,
    borderTopWidth: 2,
    fontSize: 12,
    textAlign: "center",
    fontWeight: "heavy",
    padding: 4,
  },
  itemqty: {
    width: "10%",
    borderRightColor: borderColor,
    borderTopWidth: 2,
    borderRightWidth: 2,
    fontSize: 12,
    textAlign: "center",
    fontWeight: "heavy",
    padding: 4,
  },
  itemRate: {
    width: "10%",
    borderRightColor: borderColor,
    borderTopWidth: 2,
    borderRightWidth: 2,
    fontSize: 12,
    textAlign: "center",
    fontWeight: "heavy",
    padding: 4,
  },
  items: {
    display: "flex",
    flexDirection: "row",
    // borderBottomWidth:2, // items ke beech me lines ke liye
    alignItems: "center",
  },
  sNodynamic: {
    width: "10%",
    fontSize: 11,
    textAlign: "center",
    fontWeight: "heavy",
    padding: 3,
  },
  itemNamedynamic: {
    width: "55%",
    borderRightColor: borderColor,
    borderRightWidth: 2,
    borderLeftWidth: 2,
    fontSize: 11,
    textAlign: "justify",
    padding: 5,
  },
  itemqtydynamic: {
    width: "10%",
    borderRightColor: borderColor,
    borderRightWidth: 2,
    fontSize: 11,
    textAlign: "center",
    fontWeight: "heavy",
    padding: 12.5,
  },
  itemRateDynamic: {
    width: "10%",
    borderRightColor: borderColor,
    borderRightWidth: 2,
    fontSize: 11,
    textAlign: "center",
    fontWeight: "heavy",
    padding: 12.5,
  },
  itemPricedynamic: {
    width: "15%",
    // borderRightColor: borderColor,
    // borderLeftWidth:2,
    fontSize: 11,
    textAlign: "center",
    fontWeight: "heavy",
    padding: 4,
  },
  termsContanier: {
    display: "flex",
    flexDirection: "row",
    borderTopWidth: 2,
    borderBottomWidth: 2,
    alignItems: "center",
  },
  termsRow: {
    width: "65%",
    // borderRightWidth: 2,
    fontSize: 11,
    textAlign: "justify",
  },
  priceRow: {
    width: "35%",
    fontSize: 11,
    textAlign: "justify",
    borderLeftWidth: 2,
  },
  subtotal: {
    display: "flex",
    flexDirection: "row",
    alignItems: "start",
    textAlign: "start",
  },
  gstMgmt: {
    width: "43%",
    borderRightWidth: 2,
    fontSize: 11,
    textAlign: "center",
    fontWeight: "heavy",
  },
  priceMgmt: {
    width: "57%",
    fontSize: 11,
    textAlign: "center",
  },
  bordrerdesign: {
    borderBottomWidth: 2,
    padding: 10,
    fontSize: 9,
  },
  paddingdesign: {
    padding: 4,
  },
  termHeading: {
    marginTop: 10,
    // marginBottom: 45,
    marginLeft: 5,
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
  },
  // footer: {
  //     height: 20,
  //     textAlign: 'center',
  //     justifyContent: 'center',
  //     marginLeft: 20
  // },
  termCondition: {
    width: "100%",
    fontSize: 12,
    textAlign: "justify",
    fontWeight: "heavy",
    padding: 4,
  },
  priceWord: {
    display: "flex",
    flexDirection: "column",
  },
  priceinWorld: {
    fontSize: 10,
    textAlign: "justify",
    fontWeight: "heavy",
  },
  bankInformation: {
    borderBottomWidth: 2,
    fontSize: 10,
    textAlign: "justify",
  },
  advanceMgmt: {
    paddingRight: 10,
    paddingLeft: 10,
    fontSize: 12,
    borderBottomWidth: 2,
    padding: 7,
  },
});

const InvoicePdf = ({ pdfData, merchantInfo }) => {
  console.log("pdf", pdfData);
  const toWords = new ToWords({
    localeCode: "en-IN",
    converterOptions: {
      currency: true,
      ignoreDecimal: false,
      ignoreZeroCurrency: false,
      doNotAddOnly: false,
      currencyOptions: {
        name: "Rupee",
        plural: "Rupees",
        symbol: "₹",
        fractionalUnit: {
          name: "Paisa",
          plural: "Paise",
          symbol: "",
        },
      },
    },
  });
  const WordFormat = ({ grandTotal }) => {
    return <Text>{grandTotal && toWords?.convert(grandTotal)}</Text>;
  };
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.container}>
          <View style={styles.invoice}>
            <View>
              {pdfData?.gst?.invoiceMode && (
                <Text>GSTIN:{merchantInfo?.gst}</Text>
              )}
              <Text>Mob:{merchantInfo?.mob_no}</Text>
            </View>
            <View>
              {pdfData?.gst?.invoiceMode ? (
                <Text style={{ fontSize: 13, borderBottomWidth: 2 }}>
                  TAX INVOICE
                </Text>
              ) : (
                <Text style={{ fontSize: 13, borderBottomWidth: 2 }}>
                  INVOICE
                </Text>
              )}
            </View>
            <View>
              <Text>Invoice No : {pdfData?.user_id.slice(0, 4)}</Text>
              <Text>
                Invoice Date :{" "}
                {dayjs(pdfData?.createdAt).format("DD MMM, YYYY")}
              </Text>
            </View>
          </View>
          <View style={styles.title}>
            <Text style={styles.busenessName}>
              {merchantInfo?.business_name}
            </Text>
            <Text style={styles.businessAddress}>{merchantInfo?.address}</Text>
          </View>
          <View style={styles.billContanier}>
            <Text style={styles.billadd}>Customer Details</Text>
            <Text style={styles.shippAdd}>Venue Details</Text>
          </View>
          <View style={styles.billContanier}>
            <View style={styles.billadd}>
              <Text style={styles.name}>
                Name: {pdfData?.customerinfo?.customerName}
              </Text>
              <Text style={styles.name}>
                Address : {pdfData?.customerinfo?.billToAddress}
              </Text>
              {pdfData?.customerinfo?.customerGst && (
                <Text style={styles.name}>
                  Customer GST : {pdfData?.customerinfo?.customerGst}
                </Text>
              )}
              {pdfData?.customerinfo?.customerMobNo && (
                <Text style={styles.name}>
                  Mobile No.: {pdfData?.customerinfo?.customerMobNo}
                </Text>
              )}
            </View>
            <View style={styles.shippAdd}>
              <Text style={styles.name}>
                Venue Name:{pdfData?.customerinfo?.venueName}
              </Text>
              <Text style={styles.name}>
                Venue Address:{pdfData?.customerinfo?.shipToAddress}
              </Text>
              <Text style={styles.name}>
                Delivery / Event Date:
                {dayjs(pdfData?.customerinfo?.deliveryDate).format(
                  "DD MMM, YYYY"
                )}
              </Text>
            </View>
          </View>
          <View style={styles.itemContainer}>
            <Text style={styles.sNo}>S.No</Text>
            <Text style={styles.itemName}>Title</Text>
            <Text style={styles.itemqty}>Quantity</Text>
            <Text style={styles.itemRate}>Rate</Text>
            <Text style={styles.itemPrice}>Price</Text>
          </View>
          {
            <View style={styles.row}>
              {pdfData?.billitem.map((item, index) => {
                return (
                  <View style={styles.items} key={index}>
                    <Text style={styles.sNodynamic}>{index + 1}</Text>
                    <View style={styles.itemNamedynamic}>
                      <Text>{item.title}</Text>
                      <Text
                        style={{ color: "#454545", padding: 2, fontSize: 10 }}
                      >
                        {item?.description?.length > 62
                          ? `${item?.description.slice(0, 58)}... `
                          : item?.description}
                      </Text>
                    </View>
                    <Text style={styles.itemqtydynamic}>{item?.qty}</Text>
                    <Text style={styles.itemRateDynamic}>{item?.price}</Text>
                    <Text style={styles.itemPricedynamic}>
                      {Number(item?.qty * item?.price)}
                    </Text>
                  </View>
                );
              })}
            </View>
          }
          <View style={styles.termsContanier}>
            <View style={styles.termsRow}>
              <View style={styles.priceWord}>
                <View style={styles.bankInformation}>
                  <Text style={styles.paddingdesign}>Bank Details:</Text>
                  <Text style={styles.paddingdesign}>
                    Bank Name : {merchantInfo?.bank_name}
                  </Text>
                  <Text style={styles.paddingdesign}>
                    Branch : {merchantInfo?.branch_name}
                  </Text>
                  <Text style={styles.paddingdesign}>
                    Account No : {merchantInfo?.ac_no}
                  </Text>
                  <Text style={styles.paddingdesign}>
                    Bank IFSC : {merchantInfo?.ifsc_code}
                  </Text>
                  <Text style={styles.paddingdesign}>
                    UPI ID : {merchantInfo?.upi}
                  </Text>
                </View>
                <View style={styles.priceinWorld}>
                  <Text
                    style={{ padding: 4, fontSize: 10, textAlign: "center" }}
                  >
                    Total Invoice Amount in Words
                  </Text>
                  <Text
                    style={{
                      padding: 4,
                      fontSize: 10,
                      textAlign: "center",
                      fontWeight: "bold",
                    }}
                  >
                    {pdfData?.grandtotal && (
                      <WordFormat grandTotal={pdfData?.grandtotal} />
                    )}
                  </Text>
                </View>
              </View>
            </View>
            <View style={styles.priceRow}>
              <View style={styles.subtotal}>
                <View style={styles.gstMgmt}>
                  <Text style={styles.bordrerdesign}>Sub Total</Text>
                  <Text style={styles.bordrerdesign}>
                    Discount{" "}
                    {`${
                      pdfData?.discount.discountType == "percent"
                        ? `${pdfData?.discount?.discount}%`
                        : ""
                    }`}
                  </Text>
                  <Text style={styles.bordrerdesign}>
                    CGST {pdfData?.gst?.cgst}%
                  </Text>
                  <Text style={styles.bordrerdesign}>
                    SGST {pdfData?.gst?.sgst}%
                  </Text>
                  <Text style={{ padding: 10 }}>Total</Text>
                </View>
                <View style={styles.priceMgmt}>
                  <Text style={styles.bordrerdesign}>
                    {Number(pdfData?.totalamount).toFixed(2)}
                  </Text>
                  <Text style={styles.bordrerdesign}>
                    {pdfData?.discount?.totalDiscount}
                  </Text>
                  <Text style={styles.bordrerdesign}>
                    {pdfData?.gst?.cgstAmount}
                  </Text>
                  <Text style={styles.bordrerdesign}>
                    {pdfData?.gst?.sgstAmount}
                  </Text>
                  <Text style={{ padding: 10 }}>
                    {Number(pdfData?.grandtotal).toFixed(2)}
                  </Text>
                </View>
              </View>
            </View>
          </View>
          {pdfData?.advance?.amount && (
            <View style={{ flexDirection: "row" }}>
              <View style={{ width: "65%" }}>
                <Text style={styles.advanceMgmt}>
                  Advance payment received on{" "}
                  {dayjs(pdfData?.advance?.date).format("DD MMM, YYYY")}, by{" "}
                  {pdfData?.advance?.paymentMode}
                </Text>
              </View>
              <View style={{ width: "35%", borderBottomWidth: 2 }}>
                <View
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    borderLeftWidth: 2,
                  }}
                >
                  <View style={{ width: "43%", borderRightWidth: 2 }}>
                    <Text
                      style={{
                        textAlign: "center",
                        fontSize: 11,
                        padding: 8,
                        borderBottomWidth: 2,
                      }}
                    >
                      Advance
                    </Text>
                    <Text
                      style={{ textAlign: "center", fontSize: 11, padding: 8 }}
                    >
                      Balance Due
                    </Text>
                  </View>
                  <View style={{ width: "57%" }}>
                    <Text
                      style={{
                        textAlign: "center",
                        fontSize: 11,
                        padding: 8,
                        borderBottomWidth: 2,
                      }}
                    >
                      {pdfData?.advance?.amount}.00
                    </Text>
                    <Text
                      style={{ textAlign: "center", fontSize: 11, padding: 8 }}
                    >
                      {pdfData?.dueamount}
                    </Text>
                  </View>
                </View>
              </View>
            </View>
          )}

          <View style={styles.termHeading}>
            <Text>Terms & Conditions</Text>
          </View>
          <View style={styles.footer}>
            {pdfData?.terminvoice.map((item, index) => {
              return (
                <View style={styles.termCondition} key={index}>
                  <Text>{item?.term}</Text>
                </View>
              );
            })}
          </View>
        </View>
      </Page>
    </Document>
  );
};

export default InvoicePdf;
